import React from "react";
import { Link } from "gatsby";

import PC1 from "./PC1";
import PC2 from "./PC2";
import PC3 from "./PC3";
import PC5 from "./PC5";
import PC6 from "./PC6";

const PlancheContactUI = ({ input, showCaption = true }) => {
  const { template, images, caption, linkObject } = input;
  const hasLink = linkObject && linkObject.link !== null;
  // console.log("showCaption", showCaption);

  const _getPlancheByTemplate = () => {
    switch (template) {
      case "pc1":
        return <PC1 input={images} />;
      case "pc2":
        return <PC2 input={images} />;
      case "pc3":
        return <PC3 input={images} />;
      case "pc5":
        return <PC5 input={images} />;
      case "pc6":
        return <PC6 input={images} />;
      default:
        return null;
    }
  };

  return (
    <section className='plancheContactUI section'>
      {_getPlancheByTemplate()}

      {showCaption && (
        <figcaption className='absolute left-md bottom-md w-full text-sm-lg md:text-lg transition-opacity'>
          <div>{caption}</div>

          {hasLink && (
            <Link to={`/${linkObject.link.slug.current}`} className='em'>
              {linkObject.label}
            </Link>
          )}
        </figcaption>
      )}
    </section>
  );
};

export default PlancheContactUI;
